export default __webpack_public_path__ + "92de6b902c5974a35e81e271af392137.svg";